import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eb1bb29"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "お知らせ", -1))
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "col-2" }, "操作"),
  /*#__PURE__*/_createElementVNode("th", { class: "col-6" }, "タイトル"),
  /*#__PURE__*/_createElementVNode("th", { class: "col-4" }, "掲載期間")
], -1))
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-edit" }, null, -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_list_content_layout = _resolveComponent("list-content-layout")!
  const _component_confirm_delete_notice = _resolveComponent("confirm-delete-notice")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_list_content_layout, null, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      operation: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            class: "btn btn-primary",
            to: { name: 'AddNotice' }
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" 追加 ")
            ]),
            _: 1
          })
        ])
      ]),
      "table-header": _withCtx(() => [
        _hoisted_4
      ]),
      "table-body": _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notices, (n) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: n.noticeId
          }, [
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_router_link, {
                class: "btn btn-warning",
                to: { name: 'EditNotice', params: { noticeId: n.noticeId } }
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["to"]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger ml-2",
                onClick: ($event: any) => (_ctx.onClickDelete(n))
              }, _hoisted_9, 8, _hoisted_7)
            ]),
            _createElementVNode("td", {
              textContent: _toDisplayString(n.title)
            }, null, 8, _hoisted_10),
            _createElementVNode("td", null, [
              _createElementVNode("span", {
                textContent: _toDisplayString(n.startDate)
              }, null, 8, _hoisted_11),
              _createTextVNode(" 〜 "),
              _createElementVNode("span", {
                textContent: _toDisplayString(n.endDate)
              }, null, 8, _hoisted_12)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.deleteTargetNotice)
          ? (_openBlock(), _createBlock(_component_confirm_delete_notice, {
              key: 0,
              title: _ctx.deleteTargetNotice.title,
              "notice-id": _ctx.deleteTargetNotice.noticeId,
              onDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteTargetNotice = null)),
              onDeleted: _cache[1] || (_cache[1] = () => { _ctx.updateList(); _ctx.deleteTargetNotice = null })
            }, null, 8, ["title", "notice-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}